module.exports = __webpack_public_path__ + "img/워로드.150e2b57.png";